import React from 'react'
import { Checkbox } from  '../'

import { ingredientColumns } from '../../pages/ingredients/ingredientsList/columns'

const compare = (selectedList, item) => selectedList.some(
  i => item.id === i.id && item.section === i.section,
)

export default ({ foodKinds, selectedList = [], handleSelectItem, groupItems, disabled }) => [
  {
    name: '',
    value: item => (
      <Checkbox
        value={groupItems ? compare(selectedList, item) : selectedList.some(existed => existed.id === item.id)}
        onChange={disabled ? null : handleSelectItem}
        name={groupItems ? `${item.id},${item.section}` : item.id }
      />
    ),
    center: true,
    contentStyle: {
      padding: '0',
      margin: '0',
      background: 'transparent',
    },
    style: {
      maxWidth: '12px',
    },
  },
  ...ingredientColumns({ foodKinds }),
]
